const cancel = 'Tühista'
const save = 'Salvesta'

export default {

  global: {
    generalError: 'Oi oi! Taotlust ei saanud töödelda. Palun laadige leht uuesti.',
    signature: 'Parimate soovidega,',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
    },

    addButton: {
      add: 'Add',
    },

    attachments: {
      add: 'Lisage CV või muud palutud dokumendid',
      placeholderWithDescription: 'Lisa kohustuslikud manused',
      remove: 'Eemalda',
      allowedFileTypes: 'Lubatud failitüübid',
      errors: {
        size: 'Fail on liiga suur, suurim lubatud suurus on 5MB.',
        empty: 'Faili andmed puuduvad',
        invalidType: fileType => `Vabandame, ${fileType} failid ei ole turvakaalutlustel lubatud`,
        typeNotWhitelisted: 'Vabandust, seda tüüpi fail pole lubatud.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Privaatsuspoliitikaga',
      termsLinkText: 'Tingimused',
      privacyPolicyText: 'Me hindame teie privaatsust: palun tutvuge meie ',
      termsText1: 'Loe läbi ja nõustu ',
      termsText2: 'enne oma isikuandmete esitamist.',
      privacyLink: 'https://new.recright.com/privacy-policy',
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Kui te ei soovi, et me teie isikuandmeid töötleme, siis võite paluda nende eemaldamist. Selleks saatke meil vastav teade aadressil ${mail}.`,
      customSupportPrivacyInfo: link => `Kui te ei soovi oma isikuandmete töötlemist, saate lasta need eemaldada, kui kirjutate meile aadressil ${link}.`,
    },

    buttons: {
      close: 'Sulge',
    },

    competencies: {
      addCompetency: 'Add a new competency',
      edit: 'Edit competencies',
      done: 'Done',
      defaultsDescription: 'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      getDefaults: 'Get default competencies',
    },

    competency: {
      warning: 'Remove competency and all its ratings?',
    },

    confirmDelete: {
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    confirm: {
      cancel: 'Eemalda võte',
      confirm: 'Proovi uuesti',
    },

    confirmButton: {
      wait: count => `Oota ${count}`,
      confirm: 'Kinnita',
    },

    controlStatus: {
      text: {
        empty: 'Sisesta andmed',
        valid: () => 'Valmis',
      },
      textarea: {
        empty: 'Sisesta andmed',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Määra',
        valid: () => 'Valmis',
      },
      file: {
        empty: 'Vali',
        valid: () => 'Muuda',
      },
      list: {
        empty: 'Lisa',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Otsi',
        valid: () => 'Valmis',
      },
    },

    emailAddresses: {
      remove: 'Eemalda',
      importCsv: 'Import CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General: 'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed: 'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General: 'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: 'Keelatud',
      content: 'Meie server keeldus viisakalt (kuid kindlalt) teie brauseri päringut täitmast. Pidage meeles, et Recrighti tohib samaaegselt kasutada ainult ühest seadmest/brauserist.',
      link: 'Avaleht',
    },

    error404: {
      heading: 'Siin pole midagi',
      content: 'Otsisime hoolega, kuid teie soovitud aadressil ei asu ühtegi veebilehte. Võimalik, et et järgisite aegunud linki või sisestasite ekslikult vale aadressi.',
      link: 'Avaleht',
    },

    error410: {
      heading: 'Suletud',
      content: 'Ametikohta ei saa näidata, sest see on suletud või on kandideerimine lõppenud.',
      link: 'Avaleht',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    cookieConsentModal: {
      title: 'Meie veebisait kasutab küpsiseid',
      body: 'Kõigi küpsiste lubamisega nõustute küpsiste salvestamisega teie seadmesse, et parandada saidil navigeerimist, analüüsida saidi kasutamist ja aidata meie turundustegevust.',
      learnMoreLinkText: 'Lisateave küpsiste kasutamise kohta',
      learnMoreLink: 'https://new.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Halda küpsiseid',
      acceptAll: 'Luba kõik küpsised',
      manageTitle: 'Halda nõusoleku eelistusi',
      necessaryCookiesTitle: 'Vajalikud küpsised',
      necessaryCookiesBody:
        'Need küpsised on veebisaidi toimimiseks vajalikud ja neid ei saa meie süsteemides välja lülitada.',
      performanceCookiesTitle: 'Jõudlusküpsised',
      performanceCookiesBody:
        'Need küpsised võimaldavad meil loendada külastusi ja liikluse allikaid, et saaksime mõõta ja parandada oma saidi jõudlust.',
      confirmChoices: 'Kinnita minu valikud',
      marketingCookiesTitle: 'Turundusküpsised',
      marketingCookiesBody:
        'Need küpsised võimaldavad meil reklaame suunata ja hinnata nende toimivust.',
      functionalCookiesTitle: 'Funktsionaalsed küpsised',
      functionalCookiesBody:
        'Neid küpsiseid kasutatakse veebilehe funktsionaalsuse parendamiseks. Ilma nende küpsisteta võib teatud funktsioonide kasutamine olla takistatud. Funktsionaalsed küpsised on seotud näiteks kiirsuhtlusteenuste (chat) ja kasutaja eelistustega',
    },

    flash: {
      starting: 'Lähtestamine...',
      connection_error_hint: 'Võrguühendust ei saanud luua. Proovige lehte uuesti laadida.',
      permission_hint: 'Peate lubama sellel veebisaidil kasutada oma veebikaamerat ja mikrofoni.',
      searching_camera_hint: 'Veebikaamera otsimine...',
      camera_reserved_hint: 'Teine rakendus või veebisait on reserveerinud teie veebikaamera.\nSulgege see rakendus ja laadige leht uuesti.',
      camera_reserved_hint_chrome_extra: 'Hea Chrome\'i kasutaja, peate lubama Recrightil veebikaamerat kasutada, seda saab teha aadressiriba all asuvast dialoogi aknast.',
      no_camera_hint: 'Veebikaamerat ei leitud.',
      no_mic_hint: 'Mikrofoni ei leitud.',
      uploading_text: 'Üleslaadimine...',
      rtmpt_in_use: 'See samm poleks vajalik, kui teie võrguadministraator lubaks RTMP kasutamist. Küsi meilt, kuidas.',
      preview_text: 'Veebikaamera on eelvaate režiimis',
      close_text: 'Sulge kaamera',
      remove_text: 'Eemalda võte',
      noflash_errortext_install: link => `Tundub, et teie seadmes pole Adobe Flash Playerit. Videote jäädvustamiseks läheb tarvis Flash-lisandmoodulit. Saate selle tõmmata siit: ${link}`,
      noflash_errortext_enable: link => `Kui te juba paigaldasite Flashi ja teile kuvatakse endiselt seda teadet, siis vaadake palun siia: ${link}`,
      noflash_errortext_differentbrowser: 'Teise võimalusena võite proovida brauserit, mis toetab jäädvustamist HTML5 vormingus. Soovitame kasutada Chrome\'i või Firefoxi.',
    },

    footer: {
      terms: 'Tingimused',
      license: 'General Terms of Service',
      privacyPolicy: 'Puutumatusnormid',
      customSupport: link => `Võtke ühendust ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Kuidas te oma intervjuu kogemust hindaksite?',
      howWouldYouRateJobAd: 'Kuidas hindaksid oma kandideerimise kogemust?',
      yourResponseIsAnonymous: 'Sinu vastus on anonüümne.',
      thankYouFeedback: 'Täname tagasiside eest!',
    },

    candidateFooter: {
      termsLink: 'https://new.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://new.recright.com/privacy-policy',
      accessibilityReportLink: 'https://new.recright.com/hubfs/RecRight_Accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Vabandust, seda tüüpi fail pole lubatud.',
      isRequired: 'See väli on kohustuslik.',
      isEmail: value => `${value} ei ole kehtiv meiliaadress.`,
      isDate: value => `${value} ei ole kehtiv kuupäev.`,
      invalidUrl: 'Kehtetu URL.',
      singleHireEndError: 'Ühte värbamist ei saa kasutada üle 60 päeva.',
      isNotTooOldForLive: 'Kuupäev on möödas.',
      isNotAfterEndDate: 'The date is after the date the job ad closes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Phone number has already been added',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists',
    },

    jobAdApplication: {
      name: 'Nimi',
      city: 'Kodulinn',
      email: 'e-post',
      phone: 'Telefoninumber',
      applyForPosition: 'Kandideeri ametikohale...',
      back: 'Tagasi',
      continue: 'Jätka',
      submit: 'Esita',
      saveForLater: 'Jätka hiljem',
      namePlaceholder: 'Sisestage oma nimi',
      emailPlaceholder: 'Sisetage oma meiliaadress',
      phonePlaceholder: 'Sisestage ome telefoninumber',
      cityPlaceholder: 'Sisestage oma praegune kodulinn',
      links: 'Lisa lingid, nt oma LinkedIn profiilile',
      legendBasicInfo: 'Põhiline teave',
      legendLinks: 'Lingid',
      legendAttachments: 'Manused',
      legendAdditionalFields: 'Lisateave',
      coverLetter: 'Kaaskiri',
      attachments: 'Manused',
      introduction: 'Kirjuta siia oma lühike sissejuhatus',
      thankYou: 'Täname.',
      luck: 'Kivi kotti!',
      close: 'Sulge',
      required: 'Tärniga märgitud üksused on kohustuslikud',
    },

    jobAdContainer: {
      endTime: date => (date ? `avatud kuni ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Kandideeri töökohale',
    },

    jobAdQuickInterview: {
      back: 'Tagasi',
      submit: 'Esita',
      saveForLater: 'Jätka hiljem',
      title: 'Lühike videointervjuu',
      description: 'Selleks, et teid paremini tundma õppida, vastake palun lühidalt meie kiirintervjuu küsimustele. Näidate oma omapära ja muutke oma kandideerimise avaldus isikupäraseks.',
      requiredNote: 'Juhime tähelepanu, et see on osa kandideerimisest ja värbaja saab teie kandideerimise avalduse kätte alles pärast seda, kui olete oma vastuse salvestanud.',
      reminderNote: 'Võite oma vastuse salvestada kohe, või hiljem meilile saadetud meeldetuletuse kaudu.',
    },

    jobAdRow: {
      responses: 'Kandideerimise avaldused',
      status: {
        open: 'Avatud',
        filled: 'Täidetud',
        cancelled: 'Tühistatud',
        done: 'Valmis',
        close: 'Sulge',
        draft: 'Suletud (mustand)',
        hidden: 'Peidetud',
      },
    },

    interviewRow: {
      responses: 'Kandidaadid',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Näita LinkedIn profiili',
    },

    linkedInButton: {
      error: 'Viga profiili lugemisel. Palun proovi uuesti.',
      buttonText: 'Kandideeri LinkedIni abil',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Saad kasutada oma LinkedIn profiili taotluse blanketi eeltäitmiseks',
      linkedInOr: 'või',
      error: 'Viga profiili lugemisel. Palun proovi uuesti.',
    },

    linkListInput: {
      addField: 'Lisa',
      removeField: 'Eemalda',
      invalidUrl: 'Kehtetu URL.',
    },

    loadingButton: {
      loading: 'Laadimine...',
      saving: 'Salvestamine...',
      sending: 'Saatmine...',
    },

    modalApplicationForm: {
      applyForPosition: 'Kandideeri ametikohale...',
      continue: 'Jätka',
      name: 'Sisestage oma nimi',
      email: 'Sisesta oma meiliaadress',
      phoneNumber: 'Sisesta oma telefoninumber',
      links: 'Võid sisestada linke',
      legendLinks: 'Lingid',
      legendAttachments: 'Manused',
      coverLetter: 'Kaaskiri',
      attachments: 'Manused',
      introduction: 'Kirjuta oma tutvustus siia',
      thankYou: 'Täname.',
      luck: 'Kivi kotti!',
      close: 'Sulge',
    },

    modalConfirm: {
      cancel,
      confirm: 'OK',
    },

    modalAlert: {
      close: 'Sulge',
    },

    modalLinkShare: {
      title: 'Jagatav avalik link',
      info: 'Siin on töökuulutuse avalik link, mida võite jagada.\nTöökuulutus on nähtav kõigile, kes ametikoha vastu huvi tunnevad ning kandideerida võivad kõik.\nKui kandideerimise avaldused hakkavad saabuma, saadetakse teile tavapärane teade.\n\nAvalik link töökuulutuse juurde:',
    },

    modalVideoAdd: {
      title: 'Lisa uus video',
      chooseTitle: 'Lisa uus video',
      titlePlaceholder: 'Sisesta video pealkiri siia',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Laadi üles uus video',
      info: 'Video maksimaalne lubatud suurus on 500 MB. Soovitame video enne üleslaadimist tihendada, nii kulub üleslaadimisele ja konvertimisele vähem aega.',
    },

    modalCandidateInfo: [
      {
        headline: 'Jäädvustage oma videovastus ',
        content: 'nii mitu korda kui soovte. Video salvestatakse kohe pärast jäädvustamist ja teil on võimalik e-postiga saadud lingi kaudu igal ajal videointervjuu juurde tagasi pöörduda',
        mobileContent: 'nii mitu korda, kui te ise soovite. Lisage intervjuule video. Näete, kuidas video intervjuu käigus üles laetakse ja salvestatakse. Saate e-postiga saadetud lingi kaudu videointervjuu juurde igal ajal tagasi pöörduda. <br><br><strong>Kui teie video kuva jääb mustaks ja kasutate Apple\'i mobiilseadet, siis selle tõrke lahendmiseks leiate juhised siit: <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">here</a>.</strong>',
      },
      {
        headline: 'Pärast video jäädvustamist ',
        content: 'veenduge, et video mängib korralikult ja teie häält on kuuldav. Kui vajutate nuppu "Esita", siis teie vastus lukstub ja seda pole enam võimalik muuta.',
      },
      {
        headline: 'Kui olete intervjuu lõpetanud, ',
        content: 'siis vajutage nuppu "Saada vastused ja lõpeta intervjuu". Pärast seda pole teil võimalik enam videointervjuu juurde tagasi pöörduda. Kui soovite selle lehekülje sulgeda ja hiljem uuesti jätkata, vajutage nuppu "Jätka hiljem".',
      },
      {
        headline: 'Kui vajate ',
        content: mailto => `videointervjuule vastamisel abi, klõpsake lehekülje alumises paremas ääres asuvat nuppu "Spikker" või saatke e-kiri aadressile ${mailto}.`,
        customContent: link => `Võtke ühendust ${link}`,
      },
    ],

    navigationBar: {
      back: 'Tagasi',
      dashboard: 'Esipaneel',
      frontpage: 'Avaleht',
    },

    personDetails: {
      stage: 'Stage',
      namePlaceholder: 'Candidate',
      contact: 'Contact',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: 'Hasn\'t yet visited the interview.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also found on ${count} other positions`,
    },

    phoneInput: {
      placeholder: example => `Telefon formaadis ${example}`,
    },

    questionsAndResponses: {
      response: 'Response',
      noResponse: 'No response',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
    },

    rating: {
      ownVote: 'Your rating',
      yourVotePlaceholder: 'You have not voted yet.',
      totalVotes: count => `Total ${count} ratings`,
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      yourRatingReset: 'Reset your vote',
      averageRating: 'Keskmine hinne',
      reset: 'lähtesta',
    },

    share: {
      share: 'Jaga üksustega',
      copy: 'Kopeeri link',
    },

    sort: {
      sort: 'Sordi',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Valitud',
      change: 'Muuda',
    },

    video: {
      videoNotFound: 'Videot töödeldakse või videot ei leitud',
      retry: 'Proovi uuesti',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Laadi üles või salvesta uus video' : 'Vali fail'),
      videoPlaceholder: 'Salvestage oma vastus',
      uploadPlaceholderCandidate: 'Laadi video üles',
      submit: 'Esita vastus',
      notAnswered: 'Te pole veel vastanud',
      remove: 'Eemalda võte',
      converting: 'Videot konverditakse. Palun oodake...',
      uploading: 'Videot laetakse üles. Palun oodake...',
      error: {
        invalid: 'Valitud fail on liiga suur. Palun valige teine fail.',
        upload: 'Video üleslaadimine ebaõnnestus, vabandame. Palun proovige uuesti.',
        transcode: 'Valitud videofail oli rikutud või kehtetu, palun proovige uuesti.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Näita rohkem',
      showLessButtonText: 'Näita vähem',
      infoText1:
        'Hoia vahekaart salvestamise ajal esiplaanil aktiivsena. Ära kasuta salvestamise ajal ühtegi muud rakendust.',
      infoText2:
        'Videofooniga videod töötavad kõige paremini uusimates brauserites ja koos suhteliselt uue ja võimsa seadmega.',
      infoText3:
        'Veendu, et teised rakendused ei kasuta mikrofoni ega kaamerat.',
    },

    videoResponse: {
      videoPlaceholder: 'Salvestage oma vastus',
      uploadPlaceholder: 'Laadi video üles',
      submit: 'Esita vastus',
      notAnswered: 'Te pole veel vastanud',
      startInterview: 'Alustage intervjuud',
    },

    webcam: {
      useVideoBgButtonText: 'Kasuta videofooni',
      removeVideoBgButtonText: 'Eemalda videofoon',
      starting: 'Alustamine...',
      close: 'Sulge kaamera',
      remove: 'Eemalda võte',
      record: 'Jäädvusta',
      stop: 'Seiska',
      retake: 'Salvesta uuesti',
      submit: 'Esita vastus',
      converting: 'Videot konverditakse, Palun oodake...',
      uploading: 'Videot laetakse üles. Palun oodake...',
      downloading: 'Videot laetakse alla. Palun oodake...',
      processing: 'Töötlemine...',
      uploadInProgress: 'Video edastamine on pooleli, ärge sulgege brauserit ega vahetage lehte.',
      uploaded: 'Video on edastatud.',
      error: {
        DevicesNotFoundError: 'Ei saa kaamerat või mikrofoni kasutada. Palun kontrollige, kas nende kasutamine on lubatud.',
        NotFoundError: 'Ei saa kaamerat või mikrofoni kasutada. Palun kontrollige, kas nende kasutamine on lubatud.',
        NotAllowedError: 'Te ei andnud luba kaamera või mikrofoni kasutamiseks.',
        PermissionDismissedError: 'Jätsite õiguste andmise dialoogi vahele. Palun andke luba kaamera ja mikrofoni kasutamiseks.',
        PermissionDeniedError: 'Keelasite juurdepääsu kaamerale või mikrofonile.',
        NotReadableError: 'Ei saa lugeda kaamera või mikrofoni voogu. Võimalik riistvara probleem.',
        SecurityError: 'Ei saa turvavea tõttu kaamerat või mikrofoni kasutada',
        stream: 'Ilmnes viga. Palun taaskäivitage oma brauser. Kui probleem püsib, proovige kasutada teist brauserit.',
        download: 'Video allalaadimine nurjus. Proovin uuesti?',
        upload: 'Video üleslaadimine nurjus. Proovin uuesti?',
        emptyBlob: 'Teie brauseri või seadme mälu on täis ja jäädvustamine ei ole võimalik. Palun värskendage seda lehte ja kui see ei aita, siis taaskäivitage brauser. Kui probleem püsib, proovige kasutada teist brauserit.',
        alternativeRecorder: 'Faili saab üles laadida ka klikates siin.',
        reconnecting: 'Ühendus katkes. Üritame ühendust taastada.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `Tere! Soovime kutsuda teid videointervjuule ${title}! See kutse saadeti teile ka e-posti aadressile. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
